// extracted by mini-css-extract-plugin
export default {"expiredImg":"AppErrorPage_expiredImg__jT6NI","imgWrapper":"AppErrorPage_imgWrapper__UD7y7","wrapper":"AppErrorPage_wrapper__Q4Int"};